import React, {useState} from "react";
import {useRequiredStore} from "../../../../../utils/store";
import {AgentDataStoreContext} from "../../agent.data.store";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {ComponentPropsFromRoute} from "../../../../../routers/routers";
import {Button, Col, Form, Row, Typography} from "antd";
import {accountService} from "../../../../../services/accounts/account.service";
import {notifications} from "../../../../../services/notifications/notifications";
import {
    UIInputWidgetBusinessRegion
} from "../../../../common/ui/input/widget/ic/business-region/ui.input.widget.business-region";
import {
    UIInputWidgetResponsiblePerson
} from "../../../../common/ui/input/widget/ic/responsible-person/ui.input.widget.responsible-person";

export const AgentData1C: React.FC<ComponentPropsFromRoute> = ({name}) => {
    const {account, loadData} = useRequiredStore(AgentDataStoreContext);
    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    if (!account) {
        return <></>;
    }

    const submit = async (values: any) => {
        setLoading(true)
        try {
            await accountService.updateIC(account.id, values)
            await loadData()
            notifications.successfully()
        } catch (e: any) {
            if (e.response?.data.fields) {
                form.setFields(e.response?.data?.fields);
            }
        } finally {
            setLoading(false);
        }
    }

    const defaultValues = {
        responsiblePerson: account.responsiblePerson?.id,
        businessRegion: account.businessRegion?.id,
    }

    return <Form
        size={"middle"}
        form={form}
        layout="vertical"
        name={"client_form"}
        initialValues={defaultValues}
        onFinish={async (values) => {
            await form.validateFields();
            await submit(values)
        }}
    >
        <Typography.Title level={3}>{t("CLIENT.IC.TITLE")}</Typography.Title>
        <Row gutter={[30, 0]} align={"top"}>
            <Col span={12}>
                <Row gutter={[30, 0]} align={"top"}>
                    <Col span={24}>
                        <Form.Item name={["businessRegion"]} label={t("CLIENT.IC.BUSINESS_REGION")}>
                            <UIInputWidgetBusinessRegion />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[30, 0]} align={"top"}>
                    <Col span={24}>
                        <Form.Item name={["responsiblePerson"]} label={t("CLIENT.IC.RESPONSIBLE_PERSON")}>
                            <UIInputWidgetResponsiblePerson />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row gutter={[30, 0]} align={"top"}>
            <Col span={24}>
                <Button disabled={loading} type={"primary"} onClick={() => form.submit()}>{t("SAVE")}</Button>
            </Col>
        </Row>
    </Form>
};
